
const AccountDeletionSection = () => {
  return (
    <div className="pt-2 text-sm text-gray-600">
      <p>
        Test account holders can delete their account at: {" "}
        <a 
          href="/#/account-deletion" 
          className="text-blue-600 hover:underline"
        >
          Account Deletion Page
        </a>
      </p>
    </div>
  );
};

export default AccountDeletionSection;
